//

import { axiosRequest } from '@/util/axios-request'

// 规则-获得tab
export const getTab = data =>
  axiosRequest({
    url: '/web/payroll_rule/get_tab',
    method: 'get',
    params: data
  })

// 考勤规则-获得设置
export const getAttendance = data =>
  axiosRequest({
    url: '/web/payroll_rule/get_attendance',
    method: 'get',
    params: data
  })

export const saveAttendance = data =>
  axiosRequest({
    url: '/web/payroll_rule/save_attendance',
    data
  })

// 工资设置
export const getSalary = data =>
  axiosRequest({
    url: '/web/payroll_rule/get_salary',
    method: 'get',
    params: data
  })
export const saveSalary = data =>
  axiosRequest({
    url: '/web/payroll_rule/save_salary',
    data
  })

// 获取 税
export const getTax = params =>
  axiosRequest({
    url: '/web/payroll_rule/get_tax',
    method: 'get',
    params
  })

// 保存 税
export const saveTax = data =>
  axiosRequest({
    url: '/web/payroll_rule/save_tax',
    data
  })

// 获取 社保
export const getSocialSecurity = params =>
  axiosRequest({
    url: '/web/payroll_rule/get_social_security',
    method: 'get',
    params
  })

// 保存 税
export const saveSocialSecurity = data =>
  axiosRequest({
    url: '/web/payroll_rule/save_social_security',
    data
  })

// 导入项添加
export const createitemimport = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/createitemimport',
    data
  })

// 编辑项添加
export const updateItemImport = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/updateItemImport',
    data
  })

// 删除提示
export const isDeleteToast = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/isDeleteToast',
    data
  })

// 编辑项添加
export const deleteItemImport = data =>
  axiosRequest({
    url: '/web/payroll_sub_project/deleteItem',
    data
  })
